import React, { useMemo } from 'react'
import dynamic from 'next/dynamic'
// import { VectorSquare } from '@emotion-icons/fa-solid/VectorSquare'
import { Info } from '@emotion-icons/fa-solid/Info'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { Colors } from 'src/components/theme'
import { RankIcon } from 'src/components/insights/icons/rank'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { getMMMYYYDate } from 'src/components/insights/custom-polygon-visits/utils'
import { useRecoilValue } from 'recoil'
import * as footTrafficTrendsAtoms from 'src/atoms/custom-polygon/foot-traffic-trends'
import * as searchAtoms from 'src/atoms/search'

const CustomPolygonCategoryRankContent = dynamic(
  () => import('src/components/insights/custom-polygon-category-rank/content'),
  {
    loading: () => <FullScreenLoading />,
    ssr: false,
  }
)

const CustomPolygonCategoryRankPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  const place = useRecoilValue(searchAtoms.googlePlace)
  const { start, end } = useRecoilValue(footTrafficTrendsAtoms.dateRange)

  const subtitle = useMemo(() => {
    if (!place) {
      return ''
    }
    const startDate = getMMMYYYDate(start)
    const endDate = getMMMYYYDate(end)
    return `${place.name} · ${place.formatted_address} · ${startDate} - ${endDate}`
  }, [place, start, end])

  return (
    <InsightContainer
      insight={insight}
      color={Colors.purpleDark}
      subtitle={subtitle}
      downloadFileName="Custom Polygon Category Rank">
      <React.Suspense fallback={<FullScreenLoading />}>
        <CustomPolygonCategoryRankContent />
      </React.Suspense>
    </InsightContainer>
  )
}

export const CustomPolygonCategoryRank: Insight = {
  id: 'custom-polygon-category-rank',
  component: CustomPolygonCategoryRankPage,
  name: 'Category Rank',
  // TODO: temporarily changed icons until we solve the negotiations with unacast
  // nameIcon: VectorSquare,
  // nameIconColor: Colors.bgGreenDark,
  nameIcon: Info,
  nameIconColor: Colors.neutral400,
  icon: RankIcon,
  supportedResultTypes: ['address', 'alphamap-location'],
  // supportedResultTypes: ['address', 'area', 'alphamap-location'],
  linkTooltipFile: 'insights-link-location-visits',
}
